import { Button } from '@evaneos/b2b-ui/legacy';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import sloth from '../../../assets/sloth.svg';
import { AllActions } from '../../../shared/redux/types';

import s from '../Process.module.css';

type Props = {
    onRefresh: () => AllActions | Promise<void> | void;
    className?: string;
};

export const ErrorOverlay = ({ onRefresh, className }: Props): JSX.Element => (
    <div className={cx(s.error, className)} data-testid="error-overlay">
        <img src={sloth} alt="sloth" />
        <h2>
            <FormattedMessage id="global.error.failed_fetch" />
        </h2>
        <Button
            className={s.refresh}
            data-testid="refresh-button"
            priority="primary"
            // eslint-disable-next-line sonarjs/void-use -- explicit void for fire-and-forget async
            onClick={() => void onRefresh()}
        >
            <FormattedMessage id="global.refresh" />
        </Button>
    </div>
);
